import { render, staticRenderFns } from "./InstalledAppCard.vue?vue&type=template&id=6dc954ae&scoped=true&"
import script from "./InstalledAppCard.vue?vue&type=script&lang=js&"
export * from "./InstalledAppCard.vue?vue&type=script&lang=js&"
import style0 from "./InstalledAppCard.vue?vue&type=style&index=0&id=6dc954ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc954ae",
  null
  
)

export default component.exports